module.exports = __webpack_public_path__ + "img/division.763993bb.jpg";